export const palette = {
  primary: "rgb(164, 69, 78)",
  secondary: "rgba(110, 21, 30, 1)", //main
  tertiary: "#ff735d",
  light: "beige",
  primaryLighter: (opacity: number) => `rgb(164, 69, 78, ${opacity})`,
  secondaryLighter: (opacity: number) => `rgb(110, 21, 30, ${opacity})`,
};
